module.exports = __webpack_public_path__ + "img/next.ac0128da.svg";